import './styles/theme.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { routeTree } from './routeTree.gen';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { queryClient },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// 🔴 The admin console is ALWAYS English and ALWAYS LTR (CLAUDE.md §5: admin
// chrome is English-only by owner choice).
//
// It must assert that itself, because `lc_lang` is a cookie shared across
// `.fajrarabi.com`: signing in with an Arabic locale on the marketing site or
// the app used to leave the console rendering `<html dir="rtl" lang="ar">`,
// mirroring the whole layout. The trigger was a barrel import of
// `@fajrarabi/i18n`, whose module-load `resolveLanguage()` re-stamps the
// document from that cookie (deep-import `@fajrarabi/i18n/locales` instead).
//
// Stamping here is belt-and-braces: even if something re-introduces that
// import, the console stays LTR.
document.documentElement.lang = 'en';
document.documentElement.dir = 'ltr';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No #root element');

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
